import React from 'react';
import PropTypes from 'prop-types';

interface TimelineProps extends React.HTMLAttributes<HTMLElement> {
    // Baseline arguments
    children?: React.ReactNode;
    className?: string;
}

/**
 * The overarching element for timelines. Should be populated with `TimelineItem`.
 * 
 * ## _
 * ### Arguments
 * @param {React.ReactNode} children - The contents inside the timeline. These should be of type `TimelineItem`.
 * @param {string} className - CSS classes to apply to the timeline wrapper.
 */
class Timeline extends React.Component<TimelineProps> {
    static propTypes = {
        children: PropTypes.node,
        className: PropTypes.string,
    }

    static defaultProps = {
        className: "",
    }

    render() {
        const { children, className, ...rest } = this.props;

        let classes = `o-timeline`
        if (className) classes += ` ${className}`

        return (
            <ul className={classes} {...rest}>
                {children}
            </ul>
        );
    }
}

export default Timeline;